import { render, staticRenderFns } from "./addside.vue?vue&type=template&id=0cf9197a&scoped=true&"
import script from "./addside.vue?vue&type=script&lang=js&"
export * from "./addside.vue?vue&type=script&lang=js&"
import style0 from "./addside.vue?vue&type=style&index=0&id=0cf9197a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9197a",
  null
  
)

export default component.exports